import React from "react";
import { Draggable } from "components/drag-and-drop";
import { Brikk } from "components/Brikk";
import { SeeMoreButton } from "components/form-elements/buttons/SeeMoreButton";
import { Image } from "components/media/Image";
import { HeartCalendarIcon } from "assets/icons/brikks/HeartCalendarIcon";
import brikkPreviewSrc from "./assets/refreshments-brikk-preview.png";

export const RefreshmentsFika = ({ position }) => {
  return (
    <>
      <Draggable position={position}>
        <Brikk disabled={true}>
          <Brikk.Header
            icon={<HeartCalendarIcon />}
            heading="refreshmentsFika"
          />

          <Brikk.Content center>
            <Image src={brikkPreviewSrc} />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton disabled={true} brikkNameIntl="fika" />
          </Brikk.Button>
        </Brikk>
      </Draggable>
    </>
  );
};
